import Link from "next/link";
import parse from "html-react-parser";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Tags from "@/components/static/Tags";
import Tag from "@/components/static/Tag";
import Button from "@/components/static/Button";
import { PostProps, TermProps } from "@/lib/types";
import dateFormat from "dateformat";

export default function Post({
    post,
    translations,
    locale,
}: {
    post: PostProps;
    translations: any;
    locale: string;
}) {
    // const startDate = new Date(post.acf?.event?.startDate ?? post.date).toLocaleDateString(
    //     "de-DE",
    //     {
    //         year: "numeric",
    //         month: "long",
    //         day: "2-digit",
    //     }
    // );

    const startDate = new Date(post.acf?.event?.startDate || post.date);

    const endDate = post.acf?.event?.endDate
        ? new Date(post.acf.event.endDate).toLocaleDateString("de-DE", {
              year: "numeric",
              month: "long",
              day: "2-digit",
          })
        : false;

    return (
        <Link href={post.link ?? ""} className={cn("relative flex flex-col w-full")}>
            <div className='relative flex justify-center items-center h-[18rem] w-full overflow-hidden bg-secondary'>
                {post._embedded?.["wp:term"]?.[0] && (
                    <Tags className='absolute left-0 top-0 p-3 z-10'>
                        {post._embedded["wp:term"][0]?.map((term: TermProps, i: number) => (
                            <Tag
                                key={i}
                                label={term.name}
                                className='text-white bg-stroke bg-opacity-50 backdrop-blur-md text-[16px] px-2 py-1'
                            />
                        ))}
                    </Tags>
                )}
                {post._embedded?.["wp:featuredmedia"]?.[0] && (
                    <Image
                        src={post._embedded["wp:featuredmedia"][0].source_url ?? ""}
                        alt={post._embedded["wp:featuredmedia"][0].alt_text ?? ""}
                        width={post._embedded["wp:featuredmedia"][0].media_details.width ?? ""}
                        height={post._embedded["wp:featuredmedia"][0].media_details.height ?? ""}
                        className={cn(
                            "absolute w-full h-full rounded-[10px] object-fit",
                            post.acf.type == 28
                                ? "object-contain object-center max-w-[80%] max-h-[80%] mx-auto"
                                : "object-cover"
                        )}
                    />
                )}
            </div>
            <div className='mt-6 flex flex-col flex-grow'>
                <div className='flex flex-col flex-grow gap-3'>
                    <PostDate
                        start={startDate}
                        end={endDate}
                        location={post.acf?.event?.location}
                        country={post.acf?.event?.country}
                    />
                    <h3 className='text-h5 text-primary leading-[140%] hover:text-brand transition'>
                        {post.title.rendered}
                    </h3>
                    <div className='text-textSecondary'>{parse(post.excerpt.rendered)}</div>
                </div>
                <Button as='button' type='text' className='mt-4 text-brand-light'>
                    {translations.readArticle[locale]}
                </Button>
            </div>
        </Link>
    );
}

const PostDate = ({
    start,
    end,
    location,
    country,
}: {
    start: Date;
    end?: string | boolean;
    location?: string;
    country?: string;
}) => {
    return (
        <div className='text-base text-brand-light'>
            <span>{dateFormat(start, "d. mmmm yyyy")}</span>
            {end && <span> - </span>}
            {end && <span>{end}</span>}
            {(location || country) && <span> | </span>}
            <span>{location}</span>
            {location && country && ", "}
            <span>{country}</span>
        </div>
    );
};
